import axios from "axios";
import { getMbServerToken } from "../utils/cookieUtils";

class LoggerService {

    async log(log) {
        try {
            const authToken = getMbServerToken();

            const payload = {
                context: log.context || "NO CONTEXT",
                level: log.level,
                serviceName: "REIMBURSEMENT_FRONTEND",
                method: log.method,
                message: log.message,
                error: log.error,
                request_body: log.request_body,
                response_body: log.response_body,
                statusCode: log.status_code, 
                error: log.error
            }
            const authHeader = {
                headers: {
                    'authtoken': authToken
                }
            };
            const response = await axios.post(`${process.env.REACT_APP_REIMBURSEMENT_URL}/logging/log`, payload, authHeader);
            console.log("Log successfully sent:", response.data);
        } catch (error) {
            console.error("Error sending log:", error);
        }
    }
}

export default new LoggerService();
